import config from "../../../config/config.json";

export const cats = {
    data() {
        return {
            btn_insert: true,
            btn_up: false,
            seconds: '',
            loading: false,
            minutes: '',
            text: "لطفا یکی از گزینه ها را انتخاب کنید",
            selectOption: {
                'preliminary': 'مقدماتی',
                'medium': 'متوسط',
                'hard': 'پیشرفته',
                'true': 'فعال',
                'false': 'غیرفعال'
            },
            paginatetion: {},
            url: '/categories',
            number: 1,
            listCat: [],
            categorios: {
                id: '',
                title: '',
                text: "",
                level: '',
                status: '',
                date: '',
                count: '',
                acceptance: '',
                exam: ''
            },
            disabled: false
        }
    },

}